import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder a list, PATCHing the new order to the reorder endpoint.
// Ported from APM. Skips coarse pointers (touch) where drag handles are awkward.
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (window.matchMedia("(pointer: coarse)").matches) return

    this.sortable = Sortable.create(this.element, {
      animation: 150,
      handle: "[data-sortable-handle]",
      ghostClass: "opacity-40",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  onEnd() {
    const ids = [ ...this.element.querySelectorAll("[data-sortable-id]") ]
      .map(el => el.dataset.sortableId)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ ids })
    }).then(r => { if (!r.ok) console.error("reorder failed", r.status) })
      .catch(e => console.error("reorder error", e))
  }
}
